import * as yup from "yup";
import { ContactFormType } from "./types";

export const schema: yup.SchemaOf<ContactFormType> = yup.object({
  name: yup.string().required("Requerido"),
  phone: yup.string().required("Requerido"),
  email: yup.string().email("Formato inválido").required("Requerido"),
  message: yup.string().required("Requerido"),
});
